import api from './client';

export const productsApi = {
  list:          (params?: any) => api.get('/products', { params }),
  create:        (data: any)    => api.post('/products', data),
  categories:    ()             => api.get('/categories'),
  createCategory:(data: any)    => api.post('/categories', data),
  units:         ()             => api.get('/units'),
  createUnit:    (data: any)    => api.post('/units', data),
};
